import CloseIcon from '@mui/icons-material/Close';
import { Box, Paper, styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  borderRadius: '.5rem',
  gap: '2rem',
  padding: '.5rem',
  maxWidth: '25rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    padding: '1rem',
    maxWidth: '100%',
  },
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1.2rem',
  padding: '.9rem',
  backgroundColor: `${theme.palette.primary.main}`,
  marginBottom: '1rem',
}));

export const FiltersContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '0',
  zIndex: 10,
  backgroundColor: theme.palette.primary.main,
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '0 .5rem',
  gap: '1.5rem',
}));

export const CustomPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: 'transparent',
  width: '100%',
  maxWidth: '25rem',

  [theme.breakpoints.up('sm')]: {
    maxWidth: '35rem',
  },
  '&.MuiPaper-root': {
    width: '100%',
    maxWidth: '25rem',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '35rem',
    },
  },
}));

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  marginBottom: '1rem',
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  bottom: '0',
  display: 'flex',
  padding: '.5rem 0',
  justifyContent: 'center',
  gap: '1rem',
  flexDirection: 'column',
  backgroundColor: theme.palette.primary.main,

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
}));

export const StoresContainer = styled(Box)(({ theme }) => ({
  maxHeight: '10rem',
  overflow: 'auto',
  border: `1px solid ${theme.palette.common.white}`,
  borderRadius: '.5rem',
  padding: '.5rem',
}));

export const StoreDataContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem 0 0 ',
}));

export const SellerBankDataContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const FormSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const SectionContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));
